import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsEnum } from 'class-validator';
import { PromotionAmountTypeEnum, PromotionDiscountBehaviourEnum, PromotionDiscountLevelEnum } from '../../common';
import { PromotionExternalExposeGroup } from '../interface';
export class PromotionDiscountDto {
}
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    IsEnum(PromotionDiscountLevelEnum, { always: true }),
    ApiProperty({ enum: PromotionDiscountLevelEnum }),
    __metadata("design:type", String)
], PromotionDiscountDto.prototype, "level", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    IsEnum(PromotionAmountTypeEnum, { always: true }),
    ApiProperty({ enum: PromotionAmountTypeEnum }),
    __metadata("design:type", String)
], PromotionDiscountDto.prototype, "type", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    IsEnum(PromotionDiscountBehaviourEnum, { always: true }),
    ApiProperty({ enum: PromotionDiscountBehaviourEnum }),
    __metadata("design:type", String)
], PromotionDiscountDto.prototype, "behavior", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    ApiProperty({ type: () => Number }),
    __metadata("design:type", Number)
], PromotionDiscountDto.prototype, "amount", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    ApiPropertyOptional({ type: () => Number }),
    __metadata("design:type", Number)
], PromotionDiscountDto.prototype, "maxAmount", void 0);
//# sourceMappingURL=PromotionDiscountDto.js.map